import React from 'react';

export const isQaSite = process.env.REACT_APP_ENV === 'qa';

if (isQaSite && typeof document !== 'undefined') {
  document.documentElement.classList.add('qa-site');
}

const QaSiteBanner: React.FC = () => {
  if (!isQaSite) {
    return null;
  }

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[80] flex h-7 items-center justify-center bg-orange-500 text-sm font-bold text-black"
    >
      QA Site
    </div>
  );
};

export default QaSiteBanner;
